import axios from 'axios'

export const states_service = {

  async get_states() {
    return axios.get(`list-states`)
  },
}